const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/utils/clientSetupGetRessource.ts';
import * as com from 'App/config/com/index';
import * as liho from 'App/config/liho/index';
import * as samedan from 'App/config/samedan/index';
import * as stgag from 'App/config/stgag/index';
import * as soh from 'App/config/soh/index';
import * as sro from 'App/config/sro/index';
import * as ukbb from 'App/config/ukbb/index';
import * as uster from 'App/config/uster/index';
import * as zgks from 'App/config/zgks/index';
import * as triemli from 'App/config/triemli/index';
import * as usz from 'App/config/usz/index';
import { getMainConfigClient } from '@cistec/common_web/services/mainConfig';
import { PatAppConfiguration } from 'App/defs/setupDefs';

const getByKey = (items: any, key: string) => {
    const ress = items[key];

    if (!ress) {
        throw Error(
            `clientSetupGetSetup getByKey: can't find any custom implementation: client: ${getMainConfigClient()} ressource: ${key}`
        );
    } else {
        return ress;
    }
};

export const getConfiguration = (): PatAppConfiguration => {
    switch (getMainConfigClient()) {
        case 'com':
            return com.configuration;
        case 'liho':
            return liho.configuration;
        case 'stgag':
            return stgag.configuration;
        case 'samedan':
            return samedan.configuration;
        case 'soh':
            return soh.configuration;
        case 'sro':
            return sro.configuration;
        case 'ukbb':
            return ukbb.configuration;
        case 'uster':
            return uster.configuration;
        case 'usz':
            return usz.configuration;
        case 'zgks':
            return zgks.configuration;
        case 'triemli':
            return triemli.configuration;

        default:
            throw Error(`Mandanten not found`);
    }
};

/**
 * @deprecated This function is deprecated. Please use {@link getConfiguration} instead.
 */
export function getSetupResource(key: string) {
    const mandant = getMainConfigClient();
    const clientsWithIgnoreList = ['sro', 'uster', 'usz', 'triemli'];
    const keysToIgnore = ['ECChildren', 'ECToc'];

    if (clientsWithIgnoreList.includes(mandant) && keysToIgnore.includes(key)) {
        return undefined;
    }

    switch (mandant) {
        case 'com':
            return getByKey(com, key);
        case 'liho':
            return getByKey(liho, key);
        case 'stgag':
            return getByKey(stgag, key);
        case 'samedan':
            return getByKey(samedan, key);
        case 'soh':
            return getByKey(soh, key);
        case 'sro':
            return getByKey(sro, key);
        case 'ukbb':
            return getByKey(ukbb, key);
        case 'uster':
            return getByKey(uster, key);
        case 'usz':
            return getByKey(usz, key);
        case 'triemli':
            return getByKey(triemli, key);
        case 'zgks':
            return getByKey(zgks, key);

        default:
            throw Error(
                `clientSetupGetSetup:getSetupResource: can't find custom implementation: client: ${getMainConfigClient()} ressource: ${key} - you probably did miss an import - check index.ts too. Trying to use com instead`
            );
    }
}
